import React from 'react';

import {NodeDetailsSidepanelContext} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/nodes/NodeDetailsSidepanelContext';
import CreateProcessTaskDefinitionEditor from 'processes/settings/CreateProcessTaskDefinitionEditor';

import {PlaceholderNode} from '../processFlowchartConfigEditorNodeTypes';

export default function PlaceholderNodeDetailsSidepanelContent(props: {
  selectedNode: PlaceholderNode;
}): JSX.Element {
  const {flowchartTaskSchema} = NodeDetailsSidepanelContext.useContext();
  return (
    <CreateProcessTaskDefinitionEditor
      restrictedToExecutionType={props.selectedNode.data.placeholderForNodeTypeData.executionType}
      restrictedToOrganizationId={flowchartTaskSchema.organization.id}
      onCreateProcessTaskDefinition={(newTaskDefinition) => {}}
    />
  );
}
